export default __webpack_public_path__ + "static/media/cointracker.8da9e0cd.jpg";